import HeroButton from "./HeroButton";
import HeroDescription from "./HeroDescription";
import HeroRoot from "./HeroRoot";
import HeroTitle from "./HeroTitle";

export const Hero = {
    Root:HeroRoot,
    Title:HeroTitle,
    Button: HeroButton,
    Description:HeroDescription
}